import React, { useContext } from 'react';
import Context from "../context/context";
import { format_date_full } from '../helpers/dates'

const SelectedDate = props => {
  const {activeFilters, language} = useContext(Context);
  const {text} = props;

  let selected_date = "";

  if (typeof activeFilters["top_filter"] != "undefined" && activeFilters["top_filter"].type == "date"){
     let top_filter = activeFilters["top_filter"];
     if (top_filter.value == "all"){
       selected_date = "Viewing all " + language.type;
     } else {
       if (top_filter.name == "daily"){
         selected_date = "Viewing " + language.type + " on ";

         let date = top_filter.options.find((f) => f.value == top_filter.value);
         if (date.name == "Today" || date.name == "Tomorrow"){
           selected_date += date.name;
         } else {
           selected_date += format_date_full(new Date(date.value * 1000), 'day');
         }

       } else if (top_filter.name == "weekly"){

         let date = new Date(top_filter.value * 1000);
         let end_day = new Date(date.getTime() + (6 * 24 * 60 * 60 * 1000));
         selected_date = format_date_full(date, 'week', end_day);

       } else if (top_filter.name == "monthly"){
         let date = new Date(top_filter.value * 1000);

         selected_date = format_date_full(date, 'month');


       } else if (top_filter.name == "yearly"){
         let date = new Date(top_filter.value * 1000);

         selected_date = format_date_full(date, 'year');


       }
     }
  }


  return (
    <>
      {text + selected_date}

    </>
  )
}

export default SelectedDate;
